import { createConfig, http } from 'wagmi';
import { injected } from 'wagmi/connectors';
import { defineChain } from 'viem'
/**
 * Web3Module 설정 파일
 * wagmi와 RainbowKit의 설정을 정의합니다.
 */

// 지원할 체인 목록
const EQHUB_CHAIN = defineChain({
  id: 5347,
  name: 'EQHub Network',
  nativeCurrency: { name: 'EQHub', symbol: 'EQHub', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['http://43.200.220.233:11832?socketKey=LLAbHJ2FfoVxCXdRoo3g6E1o_0dLM9hCQaS729jag5M'],
    },
  },
  blockExplorers: {
    default: {
      name: 'EQHub Explorer',
      url: 'https://field.feature.eqhub.eqbr.com/5347',
    },
  },
  testnet: false,
})

// 체인 설정
export const chains = [EQHUB_CHAIN];

// 지원할 지갑 커넥터 목록
export const connectors = createConfig({
  chains: [EQHUB_CHAIN],
  connectors: [
    injected(),
  ],
  transports: {
    [EQHUB_CHAIN.id]: http()
  },
  ssr: true, // SSR 설정 추가
});

// wagmi 설정
export const wagmiConfig = connectors;

// 기본 설정 내보내기
export default {
  chains,
  connectors,
  wagmiConfig,
}; 